import i18n from 'services/base/i18n';

export default {
  // Title of the page informing the user of the mode selection step
  title: () => i18n.pgettext('Pages|Add Pangolin|Profile', 'How would you like to deploy your Pangolin?'),

  // Description on the requirement of this step
  instructions: () => i18n.pgettext('Pages|Add Pangolin|Profile', 'Choose from the following deployment profiles to suit your needs. You can tweak these later.'),

  // Text for the link to continue to the next page
  next: () => i18n.pgettext('Pages|Add Pangolin|Profile', 'NEXT'),

  profileGraphFlowsTableHeaderFlow: () => i18n.pgettext('Pages|Add Pangolin|Profile|Graphs|Flows Table|Header', 'Flow'),
  profileGraphFlowsTableHeaderLocation: () => i18n.pgettext('Pages|Add Pangolin|Profile|Graphs|Flows Table|Header', 'Location'),
  profileGraphFlowsTableHeaderCovered: () => i18n.pgettext('Pages|Add Pangolin|Profile|Graphs|Flows Table|Header', 'Covered'),
  profileGraphFlowsTableDataLocationInternet: () => i18n.pgettext('Pages|Add Pangolin|Profile|Graphs|Flows Table|Data', 'Internet'),
  profileGraphFlowsTableDataLocationWifi: () => i18n.pgettext('Pages|Add Pangolin|Profile|Graphs|Flows Table|Data', 'WiFi'),
  profileGraphFlowsTableDataLocationLan: () => i18n.pgettext('Pages|Add Pangolin|Profile|Graphs|Flows Table|Data', 'LAN'),
};
